{
  "version": 1,
  "asset_id": "d181abcb-a481-44bf-b122-dafa5a4438d0",
  "project_id": "821317bb-5c16-42f2-91c7-33504f8f052a",
  "url": "/__l5e/assets-v1/d181abcb-a481-44bf-b122-dafa5a4438d0/plan-bonus.png",
  "r2_key": "a/v1/821317bb-5c16-42f2-91c7-33504f8f052a/d181abcb-a481-44bf-b122-dafa5a4438d0/plan-bonus.png",
  "original_filename": "plan-bonus.png",
  "size": 370957,
  "content_type": "image/png",
  "created_at": "2026-06-26T13:31:09Z"
}
